<template lang="pug">
  .b2b-page-factura
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
             ods-row(type='flex', justify='end')
                ods-tooltip(:content='$t("invoice_detail.buttons.download_invoice_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadInvoicePdf')
                    | {{ $t('invoice_detail.buttons.download_invoice') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.download_original_signed_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadSignedOriginal')
                    | {{ $t('invoice_detail.buttons.download_original_signed') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.download_original_formatted_tooltip")', placement='bottom')
                  ods-button(
                    v-if="canDownloadFormatted && invoiceDetailEditForm.documentFormat.startsWith('INVOIC')"
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOriginalformatted')
                    | {{ $t('invoice_detail.buttons.download_original_formatted') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.generate_metadata_tooltip")', placement='bottom')
                  ods-button(
                    v-if="canAdminIndra && ((!canDownloadMetadata && invoiceDetailEditForm.documentFormat!='XML_B2B_INVOICE') || (this.invoiceOriginal.communicationMethod && (this.invoiceOriginal.communicationMethod=='PAPER' || this.invoiceOriginal.communicationMethod=='EMAIL')))"
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleGenerateMetadata')
                    | {{ $t('invoice_detail.buttons.download_metadata') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.download_metadata_tooltip")', placement='bottom')
                  ods-button(
                    v-if="(canAdminIndra || canViewMetadataEmission) && canDownloadMetadata"
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadMetadata')
                    | {{ $t('invoice_detail.buttons.download_metadata') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.resend_invoice_tooltip")', placement='bottom')
                  ods-button(
                    v-if="canResendInvoices2"
                    type='primary',
                    icon='ods-icon-upload',
                    size='small',
                    circle,
                    @click.native='handleResendInvoice')
                    | {{ $t('invoice_detail.buttons.resend_invoice') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.visualize_with_xsl_tooltip")', placement='bottom')
                  ods-button(
                    v-if='canVisualizeWithXsl'
                    type='primary',
                    icon='ods-icon-external-link',
                    size='small',
                    circle,
                    @click.native='visualizeXsl')
                    | {{ $t('invoice_detail.buttons.visualize_with_xsl') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.cancel_invoice_tooltip")', placement='bottom')
                  ods-button(
                    v-if='invoiceDetailEditForm.cancelInvoice'
                    type='primary',
                    icon='ods-icon-lock',
                    size='small',
                    circle,
                    @click.native='handleCancelInvoice')
                    | {{ $t('invoice_detail.buttons.cancel_invoice') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.check_status_tooltip")', placement='bottom')
                  ods-button(
                    v-if='canCheckStatus && isShowCheckStatus'
                    type='primary',
                    icon='ods-icon-help',
                    size='small',
                    circle,
                    @click.native='handleCheckStatus')
                    | {{ $t('invoice_detail.buttons.check_status') }}
                ods-tooltip(:content='$t("invoice_detail.buttons.check_payment_emit_tooltip")', placement='bottom')
                  ods-button(
                    v-if='canGetPaymentData && isShowPaymentData'
                    type='primary',
                    icon='ods-icon-refund',
                    size='small',
                    circle,
                    @click.native='handleCheckPayment')
                    | {{ $t('invoice_detail.buttons.check_payment_emit') }}
      ods-form(
        ref='invoiceDetailEditForm',
        :model='invoiceDetailEditForm',
        :rules='invoiceDetailEditFormRules',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row.info
          ods-col(v-if='canEditInvoices', :span='24')
            p {{ $t('invoice_detail.info_message') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.buyer")',
              prop='buyerName')
              ods-input(
                v-model='invoiceDetailEditForm.buyerName',
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.invoice_number")',
              prop='invoiceNumber')
              ods-input(
                v-model='invoiceDetailEditForm.invoiceNumber'
                :disabled='!canEditInvoices')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.total_executable_amount")',
              prop='totalExecutableAmount')
              ods-input(
                v-model='invoiceDetailEditForm.totalExecutableAmount'
                :disabled='!canEditInvoices')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.status")',
              prop='status')
              ods-input(
                v-model='invoiceDetailEditForm.status'
                :disabled='true')
            ods-form-item(
              v-if='canChangeStatusInvoice',
              :label='$t("invoice_detail.invoice_detail_edit_form.change_state.label")',
              prop='statusId')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='invoiceDetailEditForm.statusId',
                :disabled='!canChangeStatusInvoice'
                filterable,
                clearable,
                :placeholder='$t("invoice_detail.invoice_detail_edit_form.change_state.placeholder")'
                @change='changeStatus')
                ods-option(
                  v-for='option in optionsFilterInvoiceStatus',
                  :key='option.id',
                  :label='$t("invoice_status." + option.code)',
                  :value='option.id')
            ods-form-item(
              v-if='canAdminIndra',
              :label='$t("invoice_detail.invoice_detail_edit_form.change_internal_state.label")',
              prop='internalStatusId')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='invoiceDetailEditForm.internalStatusId',
                filterable,
                clearable,
                :placeholder='$t("invoice_detail.invoice_detail_edit_form.change_internal_state.placeholder")'
                @change='changeStatus')
                ods-option(
                  v-for='option in optionsFilterInvoiceStatus',
                  :key='option.id',
                  :label='$t("invoice_status." + option.code)',
                  :value='option.id')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.communication_send_method")',
              prop='communicationMethod')
              ods-input(
                v-model='invoiceDetailEditForm.communicationMethod',
                :disabled='true')
            ods-form-item(
              v-if='canEditInvoices'
              :label='$t("invoice_detail.invoice_detail_edit_form.registerNumber")',
              prop='registerNumber')
              ods-input(
                v-model='invoiceDetailEditForm.registerNumber'
                :disabled='!canEditInvoices'
              )
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.seller")',
              prop='sellerName')
              ods-input(
                v-model='invoiceDetailEditForm.sellerName',
                :disabled='true')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.issue_date")',
              prop='issueDate')
              ods-input(
                v-model='issueDateFormatted',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.divisa")',
              prop='currencyCode')
              ods-input(
                v-model='invoiceDetailEditForm.currencyCode',
                :disabled='true')
            ods-form-item(
              v-if='invoiceDetailEditForm.internalStatus',
              :label='$t("invoice_detail.invoice_detail_edit_form.internalStatus")',
              prop='internalStatus')
              ods-input(
                v-model='invoiceDetailEditForm.internalStatus'
                :disabled='true')
            ods-form-item.hidden(
              v-if='!invoiceDetailEditForm.internalStatus',
              label=' ',
              prop='internalStatus')
              ods-input(
                v-model='invoiceDetailEditForm.internalStatus'
                :disabled='true')
            ods-form-item(
              v-if='canChangeStatusInvoice'
              :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
              prop='observations')
              ods-input(v-model='invoiceDetailEditForm.observations')
            ods-form-item(
              v-if='canAdminIndra'
              :label='$t("invoice_detail.invoice_detail_edit_form.internal_observations")',
              prop='internalObservations')
              ods-input(v-model='invoiceDetailEditForm.internalObservations')
            ods-form-item(
              :label='$t("invoice_detail.invoice_detail_edit_form.creation_date_time")',
              prop='creationDateTime')
              ods-input(
                v-model='creationDateTimeFormatted',
                :disabled='true')
            ods-form-item(
              v-if='canChangeSentFlagInvoice',
              :label='$t("invoice_detail.invoice_detail_edit_form.change_sent_flag.label")',
              prop='sentFlagState')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='invoiceDetailEditForm.sentFlagState',
                :disabled='!canChangeSentFlagInvoice',
                filterable,
                clearable,
                :placeholder='$t("invoice_detail.invoice_detail_edit_form.change_sent_flag.placeholder")')
                ods-option(
                  v-for='option in optionsInvoiceSentFlag',
                  :key='option.code',
                  :label='option.value',
                  :value='option.code')
            ods-form-item(
              v-if='canEditInvoices',
              :label='$t("invoice_detail.invoice_detail_edit_form.pending_task")',
              prop='pendingTask')
              ods-switch(
                v-model='invoiceDetailEditForm.pendingTask',
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                :disabled='!canEditInvoices')
            ods-form-item(
              v-if='!canEditInvoices'
              :label='$t("invoice_detail.invoice_detail_edit_form.registerNumber")',
              prop='registerNumber')
              ods-input(
                v-model='invoiceDetailEditForm.registerNumber'
                :disabled='!canEditInvoices')
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='canEditInvoices || canChangeStatusInvoice'
            type='primary',
            size='large'
            @click='submitInvoiceDetailEditForm("invoiceDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='canEditInvoices || canChangeStatusInvoice'
            ref='buttonCancel',
            size='large'
            type='neutral',
            @click='cancelInvoiceDetailEditForm')
            | {{ $t('buttons.btnClear') }}
    ods-module.collapse
      ods-accordion(@change="loadAttachments")
        ods-accordion-item(
          v-if='canSeeAttachments && !(invoiceDetailEditForm.fromRecadv && !canViewAttach)',
          name='1')
          template(slot='title')
            span {{ $t('invoice_detail.attachment') }}
            span.info(v-show='!attachments.length && attachmentMessage') {{ $t('invoice_detail.no_attachment') }}
          ods-tooltip(:content='$t("invoice_detail.buttons.add_attachment_tooltip")', placement='bottom')
            ods-button.button-collapse(
              v-if='canAddAttachments',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogAddInvoiceAttachment = true')
              | {{ $t('invoice_detail.buttons.add_attachment') }}

          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            :default-sort='{ prop: "creationDate", order: "descending" }',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("invoice_detail.attachments_table.filename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("invoice_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              :formatter= 'formatterCategory'
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("invoice_detail.attachments_table.size")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              align='right',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("invoice_detail.attachments_table.compressed_size")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              align='right',
              sortable='')
            ods-table-column(
              prop='creationDate',
              width='110',
              :label='$t("invoice_detail.attachments_table.creation_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("invoice_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              width='80')
              template(slot-scope='scope')
                ods-tooltip(:content='$t("buttons.btnDownload")', placement='bottom')
                  ods-button.first-button(
                    type='neutral',
                    @click='downloadAttachment')
                    ods-icon(name='download', size='16')
                ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                  ods-button(
                    v-if='canDeleteAttachments && (scope.row.erasable === null || scope.row.erasable)'
                    type='neutral',
                    @click='removeAttachment')
                    ods-icon(name='close', size='16')
      ods-accordion(@change="loadEvents")
        ods-accordion-item(
          v-if='canSeeEvents',
          name='2')
          template(slot='title')
            span {{ $t('invoice_detail.events.title') }}
            span.info(v-show='!events.length && eventMessage') {{ $t('invoice_detail.events.no_events') }}
            i(class='header-icon ods-icon-information')
          ods-row()
            ods-tooltip(:content='$t("buttons.refresh_tooltip")', placement='bottom')
              ods-button(
                v-if="canAdminIndra"
                style='float:right',
                icon='ods-icon-refresh',
                size='small',
                circle,
                @click="getInvoiceNoteEventsOnDatabase")
                | {{ $t('invoices.buttons.refresh_invoice') }}
            b2b-timeline(:events='events')
      ods-accordion(v-model='activateRelatedDocuments', @change='')
        ods-accordion-item(
          v-if='sourceRelatedDocuments.length > 0 ',
          name='3')
          template(slot='title')
            span {{ $t('invoice_detail.source_related_documents') }}
            span.info(v-show='!sourceRelatedDocuments.length') {{ $t('invoice_detail.related_documents_no_data') }}
          //- Tabla documentos relacionados de origen
          ods-table(
            v-if='sourceRelatedDocuments.length > 0 ',
            :data='sourceRelatedDocuments',
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='idSourceDocument',
              :label='$t("invoice_related_documents_table.destinationDocument")')
              template(slot-scope='scope')
                span(v-if='scope.row.idSourceDocument')
                a(
                  @click='goToDetail(scope.row.idSourceDocument, scope.row.sourceDocumentType)',
                  style='color: var(--color-bg-interactive); cursor: pointer;'
                )
                  | {{ scope.row.sourceDocumentNumber }}
            ods-table-column(
              prop='sourceDocumentType',
              :label='$t("invoice_related_documents_table.destinationDocumentType")')
              template(slot-scope='scope')
                span(v-if="scope.row.sourceDocumentType === 'INVOICE'") {{ $t('document_type.INVOICE') }}
                span(v-else-if="scope.row.sourceDocumentType === 'PURCHASEORDER'") {{ $t('document_type.PURCHASEORDER') }}
                span(v-else-if="scope.row.sourceDocumentType === 'DELIVERYNOTE'") {{ $t('document_type.DELIVERYNOTE') }}
                span(v-else-if="scope.row.sourceDocumentType === 'RECEIVEADVICE'") {{ $t('document_type.RECEIVEADVICE') }}
                span(v-else) {{ scope.row.sourceDocumentType }}
            ods-table-column(
              prop='creationDateTime'
              :label='$t("invoice_related_documents_table.date")',
              :formatter='formatterDate')

    //- Dialog Reenviar Factura
    ods-dialog(
      ref='dialogResendInvoice',
      :title='$t("invoice_detail.dialog_resend_invoice.title")',
      :visible.sync='isShowDialogResendInvoice',
      @open='handleEmailsForResendInvoice'
      @close='handleCloseDialog'
      width='30%')
      ods-form(
        ref='formDialogResendInvoice',
        :model='dialogResendInvoiceForm',
        :rules='rulesDialogResendInvoiceForm')
        ods-form-item(
          :label='$t("invoice_detail.dialog_resend_invoice.communication_method.label")',
          prop='communicationMethodId')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogResendInvoiceForm.communicationMethodId',
            filterable,
            :placeholder='$t("invoice_detail.dialog_resend_invoice.communication_method.placeholder")'
            @change='handleEmailsForResendInvoice')
            ods-option(
              v-for='option in metodosenvio',
              :key='option.id',
              :label='$t("communication_method." + option.code)',
              :value='option.id')
        ods-form-item(
          :label='$t("invoice_detail.dialog_resend_invoice.new_emails")',
          prop='newEmails',
          v-if= 'showInputNewEmails(dialogResendInvoiceForm.communicationMethodId)')
          ods-input(v-model='dialogResendInvoiceForm.newEmails')
        span.dialog-footer(slot='footer')
        ods-tooltip(:content='$t("buttons.btnConfirm")', placement='bottom')
          ods-button(
            type='primary',
            @click.native='submitResendInvoice("formDialogResendInvoice")')
            | {{ $t('buttons.btnConfirm') }}

    //- Dialog Anular Factura
    ods-dialog(
      ref='dialogCancelInvoice',
      :title='$t("invoice_detail.dialog_cancel_invoice.title")',
      :visible.sync='isShowDialogCancelInvoice',
      @close='handleCloseCancelInvoiceDialog'
      width='30%')
      ods-form(
        ref='formDialogCancelInvoice',
        :model='dialogCancelInvoiceForm',
        :rules='rulesDialogCancelInvoiceForm')
        ods-form-item(
          :label='$t("invoice_detail.dialog_cancel_invoice.motive")',
          prop='motive')
          ods-input(
            type='textarea',
            v-model='dialogCancelInvoiceForm.motive')

      span.dialog-footer(slot='footer')
        ods-tooltip(:content='$t("buttons.btnConfirm")', placement='bottom')
          ods-button(
            type='primary',
            @click.native='submitCancelInvoice("formDialogCancelInvoice")')
            | {{ $t('buttons.btnConfirm') }}

    //- Dialog Cargar Doc Adjunto
    ods-dialog(
      ref='dialogAddInvoiceAttachment',
      :title='$t("invoice_detail.dialog_add_invoice_attachment.title")',
      :visible.sync='isShowDialogAddInvoiceAttachment',
      @close='handleCloseDialogAddInvoiceAttachment',
      width='30%')
      ods-form(
        ref='formDialogAddInvoiceAttachment',
        :rules='rulesDialogAddInvoiceAttachment',
        :model='formDialogAddInvoiceAttachment')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddInvoiceAttachment.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormatsAccept.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('invoice_detail.dialog_add_invoice_attachment.file_selected') }}
        ods-form-item(v-if='canAttachmentHidden')
          ods-checkbox(v-model='formDialogAddInvoiceAttachment.checkAddAttachment')
            span {{ $t('msg_generics.upload_attachment_interlocutor') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddInvoiceAttachment("formDialogAddInvoiceAttachment")')
          | {{ $t('invoice_detail.dialog_add_invoice_attachment.load_document') }}
    payment-data-dialog(
      :showDialog="isShowDialogPaymentData",
      :paymentsData='this.paymentsData',
      :emitted='true' ,
      :invoiceNumber='this.invoiceDetailEditForm.invoiceNumber',
      @setterShowPaymentDataDialog='setterShowPaymentDataDialog')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import moment from 'moment'
import PaymentDataDialog from '@/views/facturas/PaymentDataDialog'

export default {
  name: 'b2b-page-factura',

  mixins: [Utils],

  data () {
    const validateEmail = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.no_emails'))) // Campo vacío no es válido
      } else {
        const emails = value.split(';').map(email => email.trim()) // Dividir y limpiar espacios
        if (emails.length > 5) {
          callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.max_emails'))) // Máximo 5 correos
        } else {
          const invalidEmails = emails.filter(email => !this.checkCorrectEmail(email)) // Validar cada email
          if (invalidEmails.length > 0) {
            callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.email_format'))) // Formato inválido
          } else {
            callback() // Todo válido
          }
        }
      }
    }
    return {
      // INFO
      invoiceOriginal: {}, // Factura original sin modificaciones de ningun tipo
      projectId: null, // id del proyecto de la factura
      invoiceId: null,
      invoiceDetailEditForm: {
        // EDITABLES
        statusId: null,
        internalStatusId: null,
        sentFlagState: null,
        invoiceNumber: null,
        totalExecutableAmount: null,
        pendingTask: null,
        comment: null,
        // NO EDITABLES
        status: '',
        internalStatus: '',
        buyerName: '',
        issueDate: '',
        communicationMethod: '',
        communicationMethodCheckstatus: null,
        sellerName: '',
        creationDateTime: '',
        currencyCode: '',
        observations: '',
        internalObservations: '',
        // Otros
        sent: null,
        communicationMethodCancelOption: null,
        emission: null,
        // Formato del documento
        documentFormat: '',
        cancelInvoice: null
      },
      // PAYMENT
      paymentsData: [],
      isShowDialogPaymentData: false,

      communicationMethodWithoutFormat: '',
      isShowDialogResendInvoice: false,
      canResendInvoices2: false,
      canVisualizeWithXsl: false,
      canDownloadMetadata: false,
      dialogResendInvoiceForm: {
        communicationMethodId: null,
        isDefault: null,
        newEmails: ''
      },
      rulesDialogResendInvoiceForm: {
        communicationMethodId: [{
          required: true,
          message: this.$t('msg_generics.field_required'),
          trigger: 'change'
        }],
        newEmails: [{
          validator: validateEmail,
          trigger: 'change'
        }]
      },
      isShowCheckStatus: false,
      isShowPaymentData: false,
      // Opciones flag enviada
      optionsInvoiceSentFlag: [{
        value: this.$t('invoice_sent_flag.SENT'),
        code: 'SENT'
      },
      {
        value: this.$t('invoice_sent_flag.PENDING_OF_SEND'),
        code: 'PENDING_OF_SEND'
      },
      {
        value: this.$t('invoice_sent_flag.NOT_SENT'),
        code: 'NOT_SENT'
      }],
      // Cancelación de factura
      isShowDialogCancelInvoice: false,
      dialogCancelInvoiceForm: {
        motive: null
      },
      rulesDialogCancelInvoiceForm: {
        motive: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 2500,
            message: this.$t('validations.maxlenght', { maxlenght: 2500 }),
            trigger: 'change'
          }
        ]
      },

      // ADJUNTOS
      attachments: [],
      currentRowAttachments: {},
      fileList: [],
      isShowDialogAddInvoiceAttachment: false,
      formDialogAddInvoiceAttachment: {
        checkAddAttachment: null,
        fichero: null
      },
      extensionFormatsAccept: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],
      extensionFormats: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],

      // DOCUMENTOS RELACIONADOS
      activateRelatedDocuments: [],
      sourceRelatedDocuments: [],

      // EVENTOS
      events: [],
      metodosenvio: [],
      // ACCORDION FLAGS
      eventFlag: true,
      eventMessage: false,
      attachmentFlag: true,
      attachmentMessage: false,

      // Tipo de búsqueda: emitidas
      searchType: 'EMITTED'
    }
  },

  components: {
    B2bTimeline,
    PaymentDataDialog
  },

  computed: {
    ...mapGetters([
      'optionsFilterInvoiceStatus',
      'canSeeAttachments',
      'canAddAttachments',
      'canDeleteAttachments',
      'canResendInvoices',
      'canSeeEvents',
      'canCheckStatus',
      'canChangeStatusInvoice',
      'canChangeSentFlagInvoice',
      'canEditInvoices',
      'canAttachmentHidden',
      'canCancelInvoice',
      'primaryColor',
      'canAdminIndra',
      'canDownloadFormatted',
      'canViewAttach',
      'canViewMetadataEmission',
      'canGetPaymentData'
    ]),

    rulesDialogAddInvoiceAttachment () {
      const checkExtension = (rule, value, callback) => {
        // Obtener la extension, y cuando la tengas, haces la validacion
        if (!this.validateExtension(this.formDialogAddInvoiceAttachment.fichero.name)) {
          this.formDialogAddInvoiceAttachment.fichero = null
          callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '.' + this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension_values') + this.extensionFormats.toString()))
        } else {
          this.fileList = []
          this.fileList.push(this.formDialogAddInvoiceAttachment.fichero)
          callback()
        }
      }
      return {
        fichero: [
          { required: true, message: this.$t('pendingtask.pendingtask_detail.attachments_table.fileselected'), trigger: 'click' },
          { validator: checkExtension }
        ]
      }
    },
    issueDateFormatted () { // eslint-disable-line
      if (this.invoiceDetailEditForm.issueDate) {
        return moment(this.invoiceDetailEditForm.issueDate).format(this.$t('date_format'))
      }
    },

    creationDateTimeFormatted () { // eslint-disable-line
      if (this.invoiceDetailEditForm.creationDateTime) {
        return moment(this.invoiceDetailEditForm.creationDateTime).format(this.$t('date_format_long'))
      }
    },

    invoiceDetailEditFormRules () {
      const checkNumber = (rule, value, callback) => {
        if (!this.checkCorrectNumber(value, true)) {
          callback(new Error(this.$t('msg_generics.format_invalid')))
        } else if (this.countDecimals(value) > 6) {
          callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
        }
        callback()
      }
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterInvoiceStatus.find(function (t) {
          return t.id === self.invoiceDetailEditForm.statusId
        })
        const observations = this.invoiceDetailEditForm.observations
        if (estado && (estado.code === 'REJECTED' || estado.code === 'CANCELLED' ||
              estado.code === 'ERROR' || estado.code === 'ANNULLED') &&
              !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      const checkInternalObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterInvoiceStatus.find(function (t) {
          return t.id === self.invoiceDetailEditForm.internalStatusId
        })
        const observations = this.invoiceDetailEditForm.internalObservations
        if (estado && (estado.code === 'REJECTED' || estado.code === 'CANCELLED' ||
              estado.code === 'ERROR' || estado.code === 'ANNULLED') &&
              !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      return {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' },
          { max: 60, message: this.$t('msg_generics.max_num_character', { max: 60 }), trigger: 'blur' }
        ],
        totalExecutableAmount: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' },
          { validator: checkNumber, trigger: 'blur' }
        ],
        observations: [
          { max: 2500, message: this.$t('msg_generics.max_num_character', { max: 2500 }), trigger: 'blur' },
          { validator: checkObservations, trigger: 'blur, change' }
        ],
        internalObservations: [
          { max: 2500, message: this.$t('msg_generics.max_num_character', { max: 2500 }), trigger: 'blur' },
          { validator: checkInternalObservations, trigger: 'blur, change' }
        ],
        internalnotes: [
          { max: 255, message: this.$t('msg_generics.max_num_character', { max: 255 }), trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'checkStatusInvoice',
      'getInvoiceNote',
      'getRelatedDocumentsInvoiceNote',
      'modifyInvoiceNote',
      'handleDownloadMultiInvoiceNotesPdf',
      'handleDownloadMultiInvoiceSignedOriginal',
      'downloadInvoiceFormatted',
      'downloadMetadata',
      'generateMetadata',
      'handleResendMultipleInvoices',
      'getInvoiceNoteAttachments',
      'addInvoiceNoteAttachment',
      'downloadInvoiceNoteAttachment',
      'removeInvoiceNoteAttachment',
      'getInvoiceNoteEvents',
      'getOptionsProjectCommunicationsMethods',
      'cancelInvoiceNote',
      'visualizeWithXsl',
      'getInvoicePaymentData',
      'getResendEmailsInvoiceNote'
    ]),

    changeStatus (data) {
      this.optionsFilterInvoiceStatus.find(function (t) {
        return t.id === data
      })
      this.$refs.invoiceDetailEditForm.clearValidate()
    },

    parseFloat (stringNumber) {
      if (stringNumber) return parseFloat(stringNumber.replace(',', '.'))
    },

    formatterNumber (row, column) {
      if (row[column.property]) return this.$n(row[column.property], 'table')
      else return '-'
    },

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    formatterCategory (row, column) {
      return row[column.property] ? this.$t('auditory_detail.events.code.' + row[column.property]) : ' '
    },

    // Mostrar botón consultar estado
    showCheckStatus () {
      if (this.invoiceOriginal.communicationMethod != null && this.invoiceOriginal.communicationMethodCheckStatus != null &&
      this.invoiceOriginal.communicationMethodCheckStatus === true && this.invoiceOriginal.sent === true &&
          (this.invoiceOriginal.registerNumber != null || this.invoiceOriginal.communicationMethod === 'AOC')) {
        this.isShowCheckStatus = true
      }
    },

    showPaymentData () {
      if (this.invoiceOriginal.status === 'PAID' || this.invoiceOriginal.status === 'SENT_TO_PAYMENT') {
        this.isShowPaymentData = true
      }
    },

    // Mostrar botón reenviar factura
    async showResendButton () {
      this.canResendInvoices2 = false
      try {
        if (this.invoiceOriginal.emission !== null && this.invoiceOriginal.status !== 'RETAINED') {
          // permiso para reenviar
          if (this.canResendInvoices) {
            this.canResendInvoices2 = true
          }
          this.obtainCommunicationMethodId()
        }
      } catch (error) {
        console.log('showResendButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Mostrar input para introducir nuevos emails a los que reenviar la factura
    showInputNewEmails (communicationMethodId) {
      const selectedOption = this.metodosenvio.find(option => option.id === communicationMethodId)
      if (selectedOption) {
        // Lista de códigos permitidos
        const allowedCodes = ['EMAIL', 'EMAIL_PDF', 'EMAIL_SIGNED', 'EMAIL_SIGNED_ATTACH', 'EMAIL_PDF_SIGNED', 'EMAIL_PDF_SIGNED_ATTACH', 'EMAIL_PDF_ATTACH', 'EMAIL_LINK'] // Reemplaza con los códigos deseados
        return allowedCodes.includes(selectedOption.code)
      }
      return false
    },

    // Mostrar descarga de metadatos
    async showDownloadMetadata () {
      this.canDownloadMetadata = false
      try {
        if (this.invoiceOriginal.pathFileMetadata != null) {
          this.canDownloadMetadata = true
        }
      } catch (error) {
        console.log('showDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Carga por defecto el metodo de envio en el select de reenvio
    obtainCommunicationMethodId () {
      if (this.communicationMethodWithoutFormat) {
        this.metodosenvio.forEach(element => {
          if (element.code.toUpperCase() === this.communicationMethodWithoutFormat.toUpperCase()) {
            this.dialogResendInvoiceForm.communicationMethodId = element.id
          }
        })
      }
    },

    // INFO
    async handleDownloadInvoicePdf () {
      console.log('handleDownloadInvoicePdf: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      // const idList = [this.invoiceId]
      try {
        const idList = [this.invoiceId]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadSignedOriginal () {
      console.log('handleDownloadSignedOriginal: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      const idList = [this.invoiceId]
      try {
        const params = {
          invoiceNoteId: idList,
          searchType: this.searchType
        }
        const filename = await this.handleDownloadMultiInvoiceSignedOriginal(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadSignedOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descargar 1C factura formateada - Fast Accion
    async handleDownloadOriginalformatted () {
      console.log('handleDownloadOriginalformatted: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_formatted')
      })
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        const filename = await this.downloadInvoiceFormatted(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginalformatted CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleGenerateMetadata () {
      console.log('handleGenerateMetadata: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })

      try {
        await this.generateMetadata({
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        })
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleGenerateMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadMetadata () {
      console.log('handleDownloadMetadata: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })

      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        await this.downloadMetadata(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleCheckPayment () {
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.checking')
      })
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        this.paymentsData = await this.getInvoicePaymentData(params)
        if (!this.paymentsData || this.paymentsData === '') {
          this.$notify({
            title: this.$t('invoice_detail.notification.no_results_payment'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } else {
          this.setterShowPaymentDataDialog(true)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    setterShowPaymentDataDialog (value) {
      if (!value) {
        this.paymentsData = []
      }
      this.isShowDialogPaymentData = value
    },

    handleResendInvoice () {
      this.isShowDialogResendInvoice = true
    },
    handleCloseDialog () {
      this.$refs.formDialogResendInvoice.resetFields()
    },
    async handleCheckStatus () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        await this.checkStatusInvoice(params)
        this.$notify({
          title: this.$t('invoice_detail.notification.check_status_invoice_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleCheckStatus CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Anulación de una factura
    handleCancelInvoice () {
      this.isShowDialogCancelInvoice = true
    },
    handleCloseCancelInvoiceDialog () {
      this.$refs.formDialogCancelInvoice.resetFields()
    },

    // Visualizar con xsl
    async visualizeXsl () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          documentFormat: this.invoiceDetailEditForm.documentFormat,
          searchType: this.searchType
        }

        const html = await this.visualizeWithXsl(params)

        const newTab = window.open('_blank')
        newTab.document.write(html.data)
        newTab.document.close()
      } catch (error) {
        console.log('showVisualizeButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async showVisualizeXslButton () {
      try {
        if (this.invoiceDetailEditForm.documentFormat === 'FATTURAPA12' || this.invoiceDetailEditForm.documentFormat === 'FACTURAE32' ||
          this.invoiceDetailEditForm.documentFormat === 'FACTURAE321' || this.invoiceDetailEditForm.documentFormat === 'FACTURAE322' ||
          this.invoiceDetailEditForm.documentFormat === 'FATTURAPA12_CADES' || this.invoiceDetailEditForm.documentFormat === 'FATTURAPA_SEMPLIFICATA' ||
          this.invoiceDetailEditForm.documentFormat === 'FATTURAPA_SEMPLIFICATA_CADES') {
          this.canVisualizeWithXsl = true
        }
      } catch (error) {
        console.log('showVisualizeButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Anulacion de una factura
    submitCancelInvoice (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true
          })
          console.log('submitCancelInvoice VALID: ', this.dialogCancelInvoiceForm)
          try {
            const params = {
              invoiceNoteId: this.invoiceId,
              motive: this.dialogCancelInvoiceForm.motive,
              searchType: this.searchType
            }
            await this.cancelInvoiceNote(params)
            this.$notify({
              title: this.$t('invoice_detail.notification.cancel_invoice_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            // REFRESCAMOS
            await this.getInvoiceOnDatabase()
            await this.getRelatedDocumentsOnDatabase()
          } catch (error) {
            console.log('submitCancelInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formName].resetFields()
            this.isShowDialogCancelInvoice = false
            load.close()
          }
        } else {
          console.log('submitCancelInvoice INVALID: ', this.dialogResendInvoiceForm)
          return false
        }
      })
    },

    submitResendInvoice (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.resend_invoice')
          })

          console.log('submitResendInvoice VALID: ', this.dialogResendInvoiceForm)
          try {
            const idList = [this.invoiceId]
            const params = {
              invoiceNoteId: idList,
              isDefault: false,
              communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
              searchType: this.searchType,
              newEmails: this.dialogResendInvoiceForm.newEmails.split(';')
            }
            let tittleConfirm = this.$t('invoice_detail.notification.resend_invoice_ok')
            if ((this.invoiceDetailEditForm.status.toUpperCase() === 'RETAINED' || this.invoiceDetailEditForm.status.toUpperCase() === 'RETENIDA') && this.invoiceOriginal.communicationMethod === null) {
              tittleConfirm = this.$t('invoice_detail.notification.submit_edit_invoice_ok') + '. ' + this.$t('invoice_detail.notification.resend_invoice_ko_retained')
            }
            await this.handleResendMultipleInvoices(params)
            this.$notify({
              title: tittleConfirm,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.$refs[formName].resetFields()
            this.isShowDialogResendInvoice = false
            await this.getInvoiceOnDatabase()
            await this.getRelatedDocumentsOnDatabase()
            await this.showResendButton()
          } catch (error) {
            console.log('submitResendInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
            this.isShowDialogResendInvoice = false
          } finally {
            // Get Events
            if (this.canSeeEvents) {
              await this.getInvoiceNoteEventsOnDatabase()
            }
            load.close()
          }
        } else {
          console.log('submitResendInvoice INVALID: ', this.dialogResendInvoiceForm)
          return false
        }
      })
    },

    submitInvoiceDetailEditForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.invoiceId != '_blank') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.update_invoice')
          })
          console.log('submitInvoiceDetailEditForm: ', this.invoiceDetailEditForm)
          try {
            const params = {
              invoiceId: this.invoiceId,
              invoiceNumber: this.invoiceDetailEditForm.invoiceNumber,
              statusId: this.invoiceDetailEditForm.statusId,
              pendingTask: this.invoiceDetailEditForm.pendingTask,
              totalExecutableAmount: this.parseFloat(this.invoiceDetailEditForm
                .totalExecutableAmount),
              observations: this.invoiceDetailEditForm.observations,
              registerNumber: this.invoiceDetailEditForm.registerNumber,
              sentFlagState: this.invoiceDetailEditForm.sentFlagState,
              internalStatusId: this.invoiceDetailEditForm.internalStatusId,
              internalObservations: this.invoiceDetailEditForm.internalObservations,
              searchType: this.searchType
            }

            await this.modifyInvoiceNote(params)

            // Refrescamos

            // Get Events
            if (this.canSeeEvents) {
              this.getInvoiceNoteEventsOnDatabase()
            }
            await this.getInvoiceOnDatabase()
            await this.getRelatedDocumentsOnDatabase()
            await this.showResendButton()
            // Comprobamos si se debe mostrar la descarga de metadatos
            await this.showDownloadMetadata()

            this.$refs[formName].clearValidate()

            this.$notify({
              title: this.$t('invoice_detail.notification.submit_edit_invoice_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitResendInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
          } finally {
            load.close()
          }
        } else {
          console.log('submitInvoiceDetailEditForm: ', this.invoiceDetailEditForm)
          return false
        }
      })
    },

    async cancelInvoiceDetailEditForm () {
      this.$refs.buttonCancel.$el.blur()
      await this.getInvoiceOnDatabase()
      await this.getRelatedDocumentsOnDatabase()
    },

    async getInvoiceOnDatabase () {
      try {
        if (this.invoiceId != '_blank') { // eslint-disable-line
          const params = {
            invoiceNoteId: this.invoiceId,
            searchType: this.searchType
          }
          const factura = await this.getInvoiceNote(params)
          this.invoiceOriginal = JSON.parse(JSON.stringify(factura))
          this.invoiceDetailEditForm = factura
          this.isInvoiceCanceled()
        }
      } catch (error) {
        console.log('getInvoiceOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.formatFields()
      }
    },

    async handleEmailsForResendInvoice () {
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.dialog_resend_invoice.get_emails')
      })
      if (this.showInputNewEmails(this.dialogResendInvoiceForm.communicationMethodId)) {
        await this.getResendEmails()
      }
      load.close()
    },

    async getResendEmails () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          isDefault: false,
          communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
          searchType: this.searchType,
          newEmails: this.dialogResendInvoiceForm.newEmails
        }
        const response = await this.getResendEmailsInvoiceNote(params)
        this.dialogResendInvoiceForm.newEmails = response.data.join(';')
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Documentos relacionados
    async getRelatedDocumentsOnDatabase () {
      try {
        const dataQuery = {
          query: {
            searchType: this.searchType,
            invoiceId: this.invoiceId
          }
        }
        const response = await this.getRelatedDocumentsInvoiceNote(dataQuery)
        this.sourceRelatedDocuments = response.data
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Enlace al detalle del documento y tipo de documento
    async goToDetail (documentId, documentType) {
      console.log('Go to detail: ', documentId)
      console.log('Go to document type: ', documentType)
      if (documentType === 'DELIVERYNOTE') {
        router.push({
          name: 'delivery-note-emit-detail',
          params: {
            deliveryId: documentId
          }
        })
      } else if (documentType === 'INVOICE') {
        router.push({
          name: 'factura-emitida-detail',
          params: {
            invoiceNoteId: documentId
          }
        })
      } else if (documentType === 'PURCHASEORDER') {
        router.push({
          name: 'order-received-detail',
          params: {
            orderId: documentId
          }
        })
      } else if (documentType === 'RECEIVEADVICE') {
        router.push({
          name: 'recadv-received-detail',
          params: {
            recadvId: documentId
          }
        })
      }
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowAttachments = row
    },

    renderHeaderActions: function (createElement) {
      return createElement('i', {
        class: 'ods-icon-setting'
      })
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddInvoiceAttachment.fichero = file
      this.$refs.formDialogAddInvoiceAttachment.validateField('fichero')
    },

    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    handleProgress (event, file, fileList) {
      console.log('handleProgress: ', event)
      console.log('handleProgress: ', file)
      console.log('handleProgress: ', fileList)
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo formulario al cerrar dialogo de añadir adjunto
    handleCloseDialogAddInvoiceAttachment () {
      this.$refs.formDialogAddInvoiceAttachment.resetFields()
      this.fileList = []
    },

    onSubmitAddInvoiceAttachment (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log('onSubmitAddInvoiceAttachment!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            await this.addInvoiceNoteAttachment({
              attachment: this.fileList[0],
              hidden: this.formDialogAddInvoiceAttachment.checkAddAttachment,
              invoiceNoteId: this.invoiceId,
              searchType: this.searchType
            })

            await this.getInvoiceNoteAttachmentsOnDatabase()

            this.$refs[formName].resetFields()
            this.isShowDialogAddInvoiceAttachment = false
            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('onSubmitAddInvoiceAttachment CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    async downloadAttachment () {
      console.log('downloadAttachment: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.download_attachment')
      })
      try {
        const filename = await this.downloadInvoiceNoteAttachment({
          invoiceNoteId: this.invoiceId,
          attachmentId: this.currentRowAttachments.id,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async removeAttachment () {
      this.$confirm(this.$t('draft_detail.confirm.title_delete_attachment'), {
        confirmButtonText: this.$t('draft_detail.confirm.confirm_button_delete_attachment'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        console.log('removeAttachment: ', this.invoiceId)
        const load = this.$loading({
          lock: true,
          text: this.$t('invoice_detail.load.delete_attachment')
        })
        try {
          await this.removeInvoiceNoteAttachment({
            invoiceNoteId: this.invoiceId,
            attachmentId: this.currentRowAttachments.id,
            searchType: this.searchType
          })
          await this.getInvoiceNoteAttachmentsOnDatabase()
          this.$notify({
            title: this.$t('msg_generics.delete_file_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('removeAttachment CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },
    // Get Adjuntos
    async getInvoiceNoteAttachmentsOnDatabase () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        this.attachments = await this.getInvoiceNoteAttachments(params)
      } catch (error) {
        console.log('getInvoiceNoteAttachmentsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // EVENTOS
    async getInvoiceNoteEventsOnDatabase () {
      try {
        this.events = await this.getInvoiceNoteEvents({
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        })
      } catch (error) {
        console.log('getInvoiceNoteEventsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    formatFields () {
      // Obtenemos el label de la divisa a través de su código
      if (this.invoiceDetailEditForm.currencyCode) {
        this.invoiceDetailEditForm.currencyCode = this.$t('currency.' + this.invoiceDetailEditForm.currencyCode)
      }
      // Obtenemos el label del estado de la factura a través de su código
      this.invoiceDetailEditForm.status = this.$t('invoice_status.' + this.invoiceDetailEditForm.status)
      if (this.invoiceDetailEditForm.internalStatus) {
        this.invoiceDetailEditForm.internalStatus = this.$t('invoice_status.' + this.invoiceDetailEditForm.internalStatus)
      }

      // Obtenemos el metodo de comunicacion antes de formatear para realizar comprobaciones
      this.communicationMethodWithoutFormat = this.invoiceDetailEditForm.communicationMethod

      // Obtenemos el método de recepción y el método de envío a través de su código
      if (this.invoiceDetailEditForm.communicationMethod) this.invoiceDetailEditForm.communicationMethod = this.$t('communication_method.' + this.invoiceDetailEditForm.communicationMethod)
      // Formateamos los campos que sean números al locale
      this.invoiceDetailEditForm.totalExecutableAmount = this.$n(this.invoiceDetailEditForm.totalExecutableAmount, 'decimal')
    },

    // Método que nos indica si podemos anular una factura
    isInvoiceCanceled () {
      if (this.canCancelInvoice &&
          this.invoiceOriginal.sent !== null && this.invoiceOriginal.sent &&
          this.invoiceOriginal.status !== 'PAID' &&
          this.invoiceOriginal.status !== 'ERROR' &&
          this.invoiceOriginal.status !== 'CANCELLED' &&
          this.invoiceOriginal.status !== 'ANNULLED' &&
          this.invoiceOriginal.status !== 'PENDING_OF_SIGNING' &&
          this.invoiceOriginal.status !== 'PENDING_OF_VERIFYING' &&
          (this.invoiceOriginal.cancellationRequest === null || !this.invoiceOriginal.cancellationRequest) &&
          this.invoiceOriginal.communicationMethodCancelOption !== null &&
          this.invoiceOriginal.communicationMethodCancelOption) {
        this.invoiceDetailEditForm.cancelInvoice = true
      } else {
        this.invoiceDetailEditForm.cancelInvoice = false
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 400:
        case 404:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined) {
            if (error.config.responseType === 'blob') {
              errorSms = this.$t('msg_generics.error_download_not_found')
            } else {
              errorSms = this.$t('error.e500')
            }
          } else if (errorSms && errorSms.indexOf('does not exist') > -1) {
            errorSms = 'No se puede consultar la información para este servicio'
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },
    async loadAttachments () {
      // Get Adjuntos
      if (this.canSeeAttachments && this.attachmentFlag) {
        this.attachmentFlag = false
        await this.getInvoiceNoteAttachmentsOnDatabase()
        this.attachmentMessage = true
      }
    },
    async loadEvents () {
      // Get Events
      if (this.canSeeEvents && this.eventFlag) {
        this.eventFlag = false
        await this.getInvoiceNoteEventsOnDatabase()
        this.eventMessage = true
      }
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.invoiceId = this.$route.params.invoiceNoteId
      if (this.invoiceId && this.invoiceId !== undefined) {
      // Get Info
        await this.getInvoiceOnDatabase()
        await this.getRelatedDocumentsOnDatabase()

        // Proyecto por id
        this.projectId = this.invoiceOriginal.idProject

        // Metodos de envio
        let request = null
        if (this.invoiceDetailEditForm.emission === true || this.invoiceDetailEditForm.emission === null) {
          request = {
            method: 'SEND',
            projectId: this.projectId,
            isResend: true
          }
        } else {
          request = {
            method: 'RECEIVE',
            projectId: this.projectId,
            isResend: true,
            byProject: false
          }
        }
        this.metodosenvio = await this.getOptionsProjectCommunicationsMethods(request)

        // Comprobamos si se debe mostrar el botón de consultar estados
        this.showCheckStatus()
        // Comprobamos si se debe mostrar el botón de consultar estados
        this.showPaymentData()
        // Comprobamos si se debe mostrar el boton de reenvio
        this.showResendButton()
        // Comprobamos si se debe mostrar el boton de visualizar con xsl
        this.showVisualizeXslButton()
        // Comprobamos si se debe mostrar la descarga de metadatos
        this.showDownloadMetadata()
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
    load.close()
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-factura{
  padding: 40px 40px 40px 40px;

  .ods-table {
    &__row {
      .ods-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: 0px;
        i {
          margin-left: 0px;
        }
      }
      .first-button {
        padding: 0px;
        margin-left: 0px;
        margin-right: rem(12);
        i {
          margin-left: 0px;
        }
      }
    }
  }

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;

      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
      .ods-button {
        float: right;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  ::v-deep .ods-checkbox {
    padding-top: 20px;
  }
  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
    color: transparent !important;
  }
  ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
    background-color: transparent !important;
  }
}
</style>
